import type { MbcAdminCheck } from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { mbcAdminKeys } from "@/hooks/queryKeys";

import type { InputOf } from "../../useMbcAdminMutation";

import { useMbcAdminMutation } from "../../useMbcAdminMutation";
import { updateCheck } from "../api";

export function useUpdateCheck(): UseMutationResult<
  MbcAdminCheck,
  Error,
  InputOf<typeof updateCheck>
> {
  return useMbcAdminMutation(updateCheck, mbcAdminKeys.checks());
}
